import FItemString from '../FItem/String';
import component from './component.vue';

export default class FTextarea extends FItemString {
  __component = component;

  autosize = true;

  constructor(props = {}) {
    super(props);
    if (props.autosize !== undefined) {
      this.autosize = props.autosize;
    }
  }
}
